<form [formGroup]="form" *appLoader="!form">
  <app-dialog-container
    title="{{ 'useStorage' | translate }}"
    [isValid]="false"
    (confirmButtonHandler)="save()"
    [form]="form"
    [scrollableBody]="!!chemicalExposureForm"
  >
    <div class="title">{{ 'useStorageDescription' | translate }}</div>
    <div class="row-container">
      <app-ui-input
        label="{{ 'currentStock' | translate }}"
        [control]="form.currentStock"
      ></app-ui-input>
      <app-ui-input
        label="{{ 'amount' | translate }}"
        [control]="form.amount"
        [required]="true"
        type="number"
        min="0"
      ></app-ui-input>
    </div>
    <app-ui-text-area
      [label]="'reasonForUse' | translate"
      [control]="form.reason"
      [required]="true"
    ></app-ui-text-area>
    @if (chemicalExposureForm) {
      <app-chemical-exposure-fields
        [form]="chemicalExposureForm"
        [departmentId]="data.departmentId"
      ></app-chemical-exposure-fields>
    }
  </app-dialog-container>
</form>
